import { useEffect } from "react";

export const useInterceptNavigation = (
  linksToCheck: string[],
  openModalAndSetNavigateRoute: (route: string) => void,
  shouldRedirectBeStopped: boolean,
) => {
  const checkLinks = (anchor: HTMLAnchorElement) =>
    !!anchor.dataset.testid && linksToCheck.includes(anchor.dataset.testid);

  useEffect(() => {
    const clickHandler = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      const anchor = target.closest("a");

      if (anchor instanceof HTMLAnchorElement && checkLinks(anchor)) {
        //we stop redirection to the other page
        event.preventDefault();

        //get href to redirect on confirm
        const href = anchor.getAttribute("href")!;

        openModalAndSetNavigateRoute(href);
      }
    };

    //{ capture: shouldRedirectBeStopped } -> stop redirection only for edit mode
    document.addEventListener("click", clickHandler, { capture: shouldRedirectBeStopped });

    return () =>
      document.removeEventListener("click", clickHandler, { capture: shouldRedirectBeStopped });

    // eslint-disable-next-line
  }, [openModalAndSetNavigateRoute, shouldRedirectBeStopped]);
};
